import { useCheckForDesktopMediumDevice, useCheckForMobileDevice } from '@dataplace.ai/ui-components/themes'
import styled, { css } from 'styled-components'

export const HeaderTitle = styled.span(({
  theme: {
    typography, palette,
  },
}) => css`
  ${typography.small.pt_14_semibold};
  color: ${palette.black};
`)

export const Content = styled.div(() => {
  const mediumDesktop = useCheckForDesktopMediumDevice()
  const mobile = useCheckForMobileDevice()
  const mediumOrMobile = mediumDesktop || mobile

  return css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;

  ${!mediumOrMobile && css`
    flex-direction: column;
  `}
`
})

export const ChartWrapper = styled.div`
  flex-shrink: 0;
`

export const Legend = styled.div`
  display: flex;
  flex-direction: column;
`

export const LegendItem = styled.div`
  display: flex;
  align-items: flex-start;
`

export const LegendLabel = styled.div(({ theme: { typography } }) => css`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  ${typography.tiny.pt_12_regular};
  max-width: 100px;
  word-break: break-word;
  flex-shrink: 0;
  width: 100px;
`)

export const ColorDot = styled.div<{ color: string }>(({ color }) => css`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${color};
  flex-shrink: 0;
`)

export const Value = styled.span(({ theme: { typography } }) => css`
  ${typography.tiny.pt_12_semibold};
  text-align: right;
  min-width: 35px;
  margin-left: auto;
`)
